import FloatingMenu_module_default from "./FloatingMenu.module.js";
import { MenuTitle } from "./MenuTitle.js";
import classNames from "classnames";
import { forwardRef, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Menu/FloatingMenu.tsx
/**
* A menu in a floating box, as commonly seen on desktop.
*/
var FloatingMenu = forwardRef(({ title, showTitle = true, className, children, ...props }, ref) => {
	const titleId = useId();
	return /* @__PURE__ */ jsxs("div", {
		role: "menu",
		ref,
		"aria-label": showTitle ? void 0 : title,
		"aria-labelledby": showTitle ? titleId : void 0,
		className: classNames(className, FloatingMenu_module_default.menu),
		...props,
		children: [showTitle && /* @__PURE__ */ jsx(MenuTitle, {
			className: FloatingMenu_module_default.title,
			title,
			id: titleId
		}), children]
	});
});
FloatingMenu.displayName = "FloatingMenu";
//#endregion
export { FloatingMenu };

//# sourceMappingURL=FloatingMenu.js.map